import React from 'react';
import './main.less';
import PropTypes from 'prop-types';
import cn from 'classname';

const propTypes = {
	onClick: PropTypes.func,
	icon: PropTypes.string,
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.string
	])
};
const defaultProps = {};

class Button extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		const {onClick, icon, children} = this.props;
		return (<span
			className={cn('main-menu__control-btn', icon && `main-menu__control-btn--${icon}`)}
			onClick={onClick}
		>
			<span className="main-menu__control-btn-txt">{children}</span>
		</span>);
	}
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/buttons/button/main.js